import { z } from 'zod';

export const getDaysWithoutMonitoringResponseSchema = z.record(z.string().uuid(), z.number());

export const getTimesMonitoredResponseSchema = z.record(z.string().uuid(), z.number());
